import { render, staticRenderFns } from "./MealScan.vue?vue&type=template&id=53d1f34a&scoped=true&"
import script from "./MealScan.vue?vue&type=script&lang=js&"
export * from "./MealScan.vue?vue&type=script&lang=js&"
import style0 from "./MealScan.vue?vue&type=style&index=0&id=53d1f34a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d1f34a",
  null
  
)

export default component.exports